import { useState, useCallback } from 'react';

const RANDOM_SCORE_KEY = 'biblika_random_score';

export function useRandomScore() {
  const [score, setScore] = useState(() => {
    try {
      const saved = localStorage.getItem(RANDOM_SCORE_KEY);
      return saved ? parseInt(saved, 10) : 0;
    } catch {
      return 0;
    }
  });

  const addPoints = useCallback((points) => {
    const newScore = score + points;
    setScore(newScore);
    try {
      localStorage.setItem(RANDOM_SCORE_KEY, newScore.toString());
    } catch {
      // localStorage failed, continue without persistence
    }
  }, [score]);

  const resetScore = useCallback(() => {
    setScore(0);
    try {
      localStorage.removeItem(RANDOM_SCORE_KEY);
    } catch {
      // localStorage failed, continue
    }
  }, []);

  return {
    score,
    addPoints,
    resetScore
  };
}